export default __webpack_public_path__ + "static/media/RivetsImg.eb8e9347.jpg";